import { render, staticRenderFns } from "./IgnoreWebsiteCreationActionDialog.vue?vue&type=template&id=5c18f6c9&"
import script from "./IgnoreWebsiteCreationActionDialog.vue?vue&type=script&lang=ts&"
export * from "./IgnoreWebsiteCreationActionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports